import { render, staticRenderFns } from "./YourDetailsPage.vue?vue&type=template&id=f1f3dc1a&scoped=true&"
import script from "./YourDetailsPage.vue?vue&type=script&lang=js&"
export * from "./YourDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./YourDetailsPage.vue?vue&type=style&index=0&id=f1f3dc1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f3dc1a",
  null
  
)

export default component.exports